export enum AccessPermissionType {
    NONE = 0,
    READ = 1,
    READANDWRITE = 2,
  }